
import React from "react";
import { AlertTriangle } from "lucide-react";

interface DatabaseStatusProps {
  dbStatus: string;
  subscriptionCount: number;
}

export function DatabaseStatus({ dbStatus, subscriptionCount }: DatabaseStatusProps) {
  return (
    <div className="w-full p-2 bg-gray-100 rounded mb-2 text-sm">
      <p>Database status: <span className={dbStatus.includes("Error") ? "text-red-500" : "text-green-600 font-semibold"}>{dbStatus}</span></p>
      {subscriptionCount === 0 && (
        <div className="flex items-center mt-1 text-amber-600">
          <AlertTriangle className="h-4 w-4 mr-1" />
          <span>No subscriptions found in database.</span>
        </div>
      )}
    </div>
  );
}
